import Cookies from 'js-cookie';
import { useEffect } from 'react';

import { useNonceGenerator } from '../../contexts/NonceGeneratorContextProvider';
import { buildNonce } from '../../services/auth';
import { PostAuthComponentParams } from '../../types/auth';
import { AuthToken, deriveOtpUrl, storeAuthToken } from '../../utils/authToken';
import logger from '../../utils/logger';
import { IDP_URL_PARAM } from '../../constants/auth';

export const VERIFY_EMAIL_COOKIE_NAME = 'VerifyEmail';
export const VERIFY_EMAIL_COOKIE_EXPIRATION_MS = 1 * 60 * 1000; // 1 minute

const VerifyEmail = ({
  user,
  onContinue,
  onCancel,
  config,
}: PostAuthComponentParams) => {
  const nonceGenerator = useNonceGenerator();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (
      config.enableEmailVerification !== 'true' ||
      params.get('require_email_verification') !== 'true'
    ) {
      onContinue();
    } else if (!user.jwtToken) {
      logger.debug('User is missing a JWT token, aborting the sign-in');
      onCancel();
    } else if (!user.email) {
      logger.debug('User has no email, nothing to verify');
      // Note: it is up to each LXP to display an appropriate error message here if needed
      onContinue();
    } else {
      // store current auth token
      const nonce = buildNonce(nonceGenerator);
      params.set(IDP_URL_PARAM, user.providerName);
      const authToken: AuthToken = {
        originalRequestURL: params.toString(),
        jwtToken: user.jwtToken ?? '',
        nonce,
      };
      storeAuthToken(authToken);

      // create cookie to indicate that OTP email should immediately be sent
      Cookies.set(VERIFY_EMAIL_COOKIE_NAME, user.email, {
        expires: new Date(
          new Date().getTime() + VERIFY_EMAIL_COOKIE_EXPIRATION_MS
        ),
        sameSite: 'Strict',
        secure: true,
      });

      // redirect to OTP IDP
      const redirect_url = `${window.location.origin}/verifyemails`;
      const otpUrl = deriveOtpUrl(config, nonce, redirect_url);
      window.location.assign(otpUrl);
    }
  }, [config, nonceGenerator, onCancel, onContinue, user]);

  return <></>;
};

export default VerifyEmail;
